import { PRODUCT_MODULES } from '../../presentation/productModules';
import type { PresentationModule } from '../../presentation/types';
import { ecosystem } from './content';
import { EcosystemScene } from './scenes/EcosystemScene';

export const ecosystemModule: PresentationModule = {
  id: 'ecosystem',
  label: 'Moderta ecosystem',
  priority: 'structural',
  scenes: [
    { ...ecosystem, module: 'ecosystem', requiresAny: PRODUCT_MODULES, create: (resolved) => new EcosystemScene(resolved) },
  ],
};
